export const getS57Url = () => {
  const url = `https://s-57.gatehousemaritime.com`;

  return url;
};
